/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_SearchInputs */

const cs_calendar_search = /** @type {(inputs: Calendar_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat název`)
};

const en_calendar_search = /** @type {(inputs: Calendar_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search title`)
};

/**
* | output |
* | --- |
* | "Search title" |
*
* @param {Calendar_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_search = /** @type {((inputs?: Calendar_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_search(inputs)
	return cs_calendar_search(inputs)
});